export default __webpack_public_path__ + "maps-examples-custom-callout-thumbnail-960-95c540087c9c1f883faf225450d478ef.webp";